import type { ReactNode } from 'react';

export const symbol_lock_person: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M350-634h260v-93q0-57-37.5-95T480-860q-55 0-92.5 38T350-727v93ZM220-80q-23 0-41.5-18.5T160-140v-434q0-23 18.5-41.5T220-634h70v-93q0-81 55-137t135-56q80 0 135 56t55 137v93h70q23 0 41.5 18.5T800-574v49q0 14.5-9.32 21.75t-20.5 7.25q-11.18 0-20.68-7.5T740-526v-48H220v434h298q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q530.75-80 518-80H220Zm0-494v434-434Zm580.44 305.44Q820-288.12 820-316.06T800.46-363q-19.54-19-47.46-19-27.5 0-46.75 19.35-19.25 19.36-19.25 47 0 27.65 19 47.15t46.94 19.5q27.94 0 47.5-19.56ZM815-131.5q29-15.5 47-42.5-26-14-53-22.5t-56-8.5q-29 0-56 8.5T644-174q18 27 46.79 42.5 28.78 15.5 62 15.5Q786-116 815-131.5ZM617-103q-57-57-57-136t57-136q57-57 136-57t136 57q57 57 57 136t-57 136q-57 57-136 57t-136-57Z"
		/>
	</svg>
);
